import * as XLSX from 'xlsx'
import { bulkUploadModel } from "@shared/constants";
export const SUPPORTED_FILE_FORMATS = {
  BULK_UPLOAD: ["xls", "xlsx", "csv"],
  SITE_FLOORPLAN: ["pdf", "jpg", "jpeg", "png"],
  TELECOM_BILL: ["pdf", "jpg", "jpeg", "png"],
  FEEDBACK: [
    "mov",
    "avi",
    "mp4",
    "mkv",
    "webm",
    "mpg",
    "mp2",
    "mpeg",
    "mpe",
    "mpv",
    "ogg",
    "m4p",
    "m4v",
    "wmv",
    "qt",
    "flv",
    "swf",
    "avchd",
    "jpg",
    "jpeg",
    "png",
    "gif",
    "xlsx",
    "csv",
    "pdf",
  ],
};

export const BULK_UPLOAD_EXPORT_SEPARATOR =
  "*** BEGINNING OF EXPORTED DATA ***";

export const getFileExtension = (name) => {
  const lastDot = name.lastIndexOf(".");
  const extension = name.substring(lastDot + 1);
  return extension;
};

export const isExportedTemplate = (fileData) => {
  const headerIndex = fileData.findIndex((contentRow) => {
    if (contentRow.includes(BULK_UPLOAD_EXPORT_SEPARATOR)) {
      return true;
    }

    return null;
  });
  return headerIndex !== -1;
};

export const readCSVFile = (file, readOptions = {}) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    let result = [];
    reader.onload = function() {
      const csv = reader.result;
      const lines = csv.split("\n");

      if (readOptions.header && readOptions.header === 1) {
        result = lines.map((stringRow) => stringRow.split(","));
      } else {
        const headers = lines[0].split(",");
        for (let i = 1; i < lines.length - 1; i += 1) {
          const obj = {};
          const currentline = lines[i].split(",");
          for (let j = 0; j < headers.length; j += 1) {
            obj[headers[j]] = currentline[j];
          }
          result.push(obj);
        }
      }

      resolve(result);
    };
    reader.onerror = function() {
      resolve(null);
    };
    reader.readAsText(file);
  });

// export const getExcelTabs = file =>
//   new Promise(resolve => {
//     if (!file) {
//       return null;
//     }

//     const fileExtension = getFileExtension(file.name);
//     if (fileExtension !== 'xls' && fileExtension !== 'xlsx') {
//       return null;
//     }

//     const reader = new FileReader();
//     reader.onload = function() {
//       const fileData = reader.result;
//       const wb = XLSX.read(fileData, { type: 'binary' });
//       resolve(wb.SheetNames);
//     };

//     reader.onerror = function() {
//       resolve(null);
//     };

//     reader.readAsBinaryString(file);
//   });

export const getSheetData = (workbook, sheetIdentifier) => {
  if (!(workbook && sheetIdentifier)) {
    return [];
  }

  let sheetToRead = workbook.SheetNames[0];
  if (typeof sheetIdentifier === "number") {
    sheetToRead = workbook.SheetNames[sheetIdentifier];
  } else {
    sheetToRead = sheetIdentifier;
  }
  let sheetValues = XLSX.utils.sheet_to_json(workbook.Sheets[sheetToRead], {
    defval: null,
    blankrows: false,
    header: 1,
  });

  return sheetValues;
};

export const readXLSFile = (file, options) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      resolve(workbook);
    };

    reader.onerror = function() {
      resolve(null);
    };
    reader.readAsArrayBuffer(file);
  });
};

export const getFileContent = async (file, options) => {
  let fileData = "";
  switch (getFileExtension(file.name)) {
    case "csv":
      fileData = await readCSVFile(file, options);
      break;
    case "xls":
    case "xlsx":
      fileData = await readXLSFile(file, options);
      break;
    default:
  }

  return fileData;
};

export const readFile = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });

export const readFileAsBuffer = (file) => {
  return new Promise(async (resolve, reject) => {
    try {
      // debugger;
      const arrayBuffer = await readFileAsArrayBuffer(file);
      let buffer = null;
      // debugger;
      if (arrayBuffer) {
        resolve(Buffer.from(arrayBuffer));
      }
    } catch (exception) {
      // debugger;
      reject(exception);
    }
  });
};

export const readFileAsArrayBuffer = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });

export const mapFileContent = (
  fileData = [],
  position = "Horizontal",
  section = null
) => {
  const mappedData = [];
  const modelFields = (bulkUploadModel[section] || []).map(
    (model) => model.field
  );
  let headerIndex = fileData.findIndex((contentRow = []) => {
    const row = contentRow.filter((item) => item);
    return (
      modelFields.every((item) => row.includes(item)) ||
      row.includes(BULK_UPLOAD_EXPORT_SEPARATOR)
    );
  });

  headerIndex =
    headerIndex !== -1
      ? headerIndex + (isExportedTemplate(fileData) ? 1 : 0)
      : 0;

  const dataLength =
    position === "Horizontal" ? fileData.length : fileData[0].length;
  const headerKeys =
    position === "Horizontal"
      ? fileData[headerIndex]
      : fileData.map((row) => row[0]);

  for (let index = headerIndex + 1; index < dataLength; index += 1) {
    let rowItem = {};

    headerKeys.map((key, keyIndex) => {
      rowItem = {
        ...rowItem,
        [key]:
          position === "Horizontal"
            ? fileData[index][keyIndex]
            : fileData[keyIndex][index],
      };

      return null;
    });

    mappedData.push(rowItem);
  }

  if (mappedData.length > 1) {
    return mappedData.filter(
      (item) =>
        Object.keys(item).filter((i) => item[i] && !!item[i].toString().trim())
          .length
    );
  }

  return mappedData;
};

export const writeXLSFile = async (
  fileName = "File",
  sheetName = "Sheet",
  data = [],
  write_opts = {}
) => {
  return new Promise((resolve) => {
    const workBook = XLSX.utils.book_new();
    const workSheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
    XLSX.writeFile(workBook, `${fileName}`, write_opts);
    resolve(true);
  });
};
